'use strict';

exports.__esModule = true;

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var right = /*#__PURE__*/(0, _reactEmotion.css)('right:35px;');

var MicIcon = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	target: 'e1eg17i10'
})('height:40px;position:absolute;top:8px;cursor:pointer;right:15px;', function (_ref) {
	var iconPosition = _ref.iconPosition,
	    showClear = _ref.showClear;

	if (showClear && iconPosition !== 'left') return 'right: 51px;';
	if (iconPosition === 'right' || showClear) {
		return right;
	}
	return null;
}, ' ', function (_ref2) {
	var showIcon = _ref2.showIcon,
	    showClear = _ref2.showClear;

	if (!showIcon && showClear) return 'right: 32px;';
	if (!showIcon && !showClear) return 'right: 15px;';
	return null;
}, ' width:11px;');

exports.default = MicIcon;